module.exports = __webpack_public_path__ + "static/media/Lato-Italic.fef08ee8.ttf";